<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="pt-4">
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table :data="staff"  @sort="handleSort"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th width="25%">PRODUCT CODE</vs-th>
                <vs-th width="25%">PRODUCT NAME</vs-th>
                <vs-th width="25%">MIN ORDER QTY (KG)</vs-th>
                <vs-th width="25%">PRICE Excl VAT/Tax in {{ __accountCurrency() }}</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code }}
                  </vs-td>
                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].min_order_quantity">
                    {{ data[indextr].min_order_quantity }}
                  </vs-td>

                  <vs-td>
                    <span v-if="['List'].includes(data[indextr].type)">
                      {{ data[indextr].contract_price }}
                    </span>
                    <span class="text-primary" v-if="!['List'].includes(data[indextr].type)">
                      click here to view pricing tier
                    </span>
                  </vs-td>

                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-full p-16">

                      <span v-if="['List'].includes(data[indextr].type)">
                        <h5>Price check</h5>
                        <div class="vx-row mb-3 mt-4">
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                              <small class="label">Input Quantity</small>
                              <vs-input v-on:input="onChangeQty(data[indextr], indextr)" v-model="data[indextr].quantity"  name="name" class="w-full required" label=""/>
                          </div>
                          <div class="vx-col  md:w-1/2 w-full md:mb-0">
                              <small class="label">Unit price Excl vat(KG/{{__accountCurrency()}})</small>
                              <vs-input v-model="data[indextr].unit_price" class="w-full"  name="email" type="text" label=""/>
                          </div>
                        </div>

                      </span>

                      <vs-table
                        v-if="['Bespoke', 'Contract'].includes(data[indextr].type)"
                        :data="data[indextr].price"
                        :hoverFlat="true">

                        <template slot="header">
                          <h5 class="mb-2" style="color: #626262">Price tiers</h5>
                        </template>

                        <template slot="thead">
                          <vs-th width="10%" class="text-sm">MinOQ</vs-th>
                          <vs-th width="10%" class="text-sm">MaxOQ</vs-th>
                          <vs-th width="10%" class="text-sm">Price ({{ __accountCurrency() }})</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr class="text-sm" :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                            <vs-td :data="data[indextr].from">
                              {{ data[indextr].from }}
                            </vs-td>

                            <vs-td :data="data[indextr].to">
                              {{data[indextr].to}}
                            </vs-td>

                            <vs-td :data="data[indextr].price">
                              {{data[indextr].price}}
                            </vs-td>

                          </vs-tr>
                        </template>
                      </vs-table>

                      <vs-table
                        v-if="data[indextr].application_items && data[indextr].application_items.length > 0"
                        :data="data[indextr].application_items"
                        :hoverFlat="true">

                        <template slot="header">
                          <h5 class="mb-2" style="color: #626262">Application Items</h5>
                        </template>

                        <template slot="thead">
                          <vs-th width="15%" class="text-sm">NAME</vs-th>
                          <vs-th width="15%" class="text-sm">DESCRIPTION</vs-th>
                          <vs-th width="15%" class="text-sm">CODE</vs-th>
                          <vs-th width="15%" class="text-sm">STATUS</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr class="text-sm" :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                            <vs-td :data="data[indextr].name">
                              {{ data[indextr].name }}
                            </vs-td>

                            <vs-td :data="data[indextr].description">
                              {{data[indextr].description}}
                            </vs-td>

                            <vs-td :data="data[indextr].code">
                              {{data[indextr].code}}
                            </vs-td>

                            <vs-td :data="data[indextr].is_active">
                              {{ data[indextr].is_active ? 'active' : 'de-active' }}
                            </vs-td>

                          </vs-tr>
                        </template>
                      </vs-table>

                      <!-- <h5 class="mb-4 mt-8" style="color: #626262">Product Catalogue Info</h5>
                      <p>Unit Sold In:  <span class="font-bold"> {{data[indextr].product_catalogue_info.unit_sold_in}}</span> </p>

                      <h5 class="mt-4">Documentation</h5>
                      <ol class="list-decimal">
                        <li v-for="(doc, index) in data[indextr].product_catalogue_info.documentation" :key="index">
                          <span class="ul">{{doc.name}}</span>
                          <ol class="list-decimal">
                            <li v-for="(file, index) in doc.files" :key="index">
                              <a target="_blank" :href="file">{{__nameSplitter(file)}}</a>
                            </li>
                          </ol>
                        </li>
                      </ol> -->

                    </div>
                  </template>

                </vs-tr>
              </template>

            </vs-table>


          </div>
        </vx-card>
      </div>
    </div>
    <create-supplier-pop-up ref="createSupplierPopUp"/>
    <update-supplier-pop-up ref="updateSupplierPopUp"/>
    <view-supplier-pop-up ref="viewSupplierPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const SupplierRepository = RepositoryFactory.get('supplier')
  const CustomerRepository = RepositoryFactory.get('customer')
  import CreateSupplierPopUp from '@/components/popups/supplier/CreateSupplierPopUp'
  import UpdateSupplierPopUp from '@/components/popups/supplier/UpdateSupplierPopUp'
  import ViewSupplierPopUp from '@/components/popups/supplier/ViewSupplierPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations'
  import store from "../../../store/store";


  export default {
    name: 'AllUsersList',
    data () {
      return {
        selected: [],
        updateStaffSelected: [],
        options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
        popupActive: false,
        createUserPopupActive: false,
        popUpTitle: '',
        editActive: false,
        edit: null,
        editProp: {},
        checkBox1: false,
        activeConfirm: false,
        staff: [],
        selectedStaff: {},
        createStaffForm: {},
        departments: [],
        users: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        currentUser: {},
        form: {}
      }
    },
    components: {
      'v-select': vSelect,
      CreateSupplierPopUp,
      UpdateSupplierPopUp,
      ViewSupplierPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages, Calculations],
    async mounted () {
      this.currentUser = store.getters.currentUser
    },
    methods: {
      async refreshData () {
        this.loadStaff()
      },
      onChangeQty(data, index) {
        this.staff[index].unit_price = this.calculateProductListPrice(data.pe_g, data.quantity, data.fx_rate)
      },
      async loadStaff() {
        this.$vs.loading()
        const {data} = await CustomerRepository.getProductCatalogueList(this.page, this.filterQuery, 10)
        this.staff =  data.data.map((n) => {
          n.quantity = 0
          n.unit_price = 0
          return n
        })
        this.$vs.loading.close()
      },
      openConfirm () {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Remove Confirm',
          text: 'Are you sure you want to permanently remove this organization?',
          accept: this.acceptAlert
        })
      },

      acceptAlert () {
        this.$vs.notify({
          color: 'danger',
          title: 'Deleted Organization',
          position:'top-right',
          text: 'The selected organization was successfully deleted'
        })
      },
      openStatusChangeConfirm (id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: status === 'activate' ? 'success' : 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.changeUserStatus,
          parameters: [id, status]
        })
      },
      async changeUserStatus (params) {
        console.log(params)
        this.$vs.loading()
        try {
          await SupplierRepository.changeCustomerUserStatus(params[0], params[1])
          this.showSuccessMessage('Customer user status updated!')
          await this.loadStaff()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreateUser () {
        await this.$refs.createSupplierPopUp.openPopup()
      },
      async onClickSupplierUpdate (id) {
        await this.$refs.updateSupplierPopUp.openPopup(id)
      },
      async onClickSupplierEmailResend (email) {
        this.$vs.loading()
        try {
          const {data} = await SupplierRepository.customerUserWelcomeEmailResend(email)
          this.showSuccessMessage('Email resend successfully!')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickSupplierView (id) {
        await this.$refs.viewSupplierPopUp.openPopup(id)
      },
      filterQueryUpdate (){
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }

      },
      userListStatusColorFactory(status_id) {
        switch (status_id) {
          case 1:
            return 'dark';
          case 2:
            return 'warning';
          case 3:
            return 'primary';
          case 4:
            return 'danger';
        }
      },

    },
    watch : {
      page(){
        this.loadStaff()
      },
      // staff: {
      //   handler(val, oldVal) {
      //     this.staff[1].unit_price = 25
      //   },
      //   deep: true
      // },
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
